<!-- Icon sprite of the provider template (exact paths). Referenced with <use href="#drf-i-…">. -->
<svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">
  <symbol id="drf-i-book" viewBox="0 0 24 24"><path d="M3 5.5A1.5 1.5 0 0 1 4.5 4H10a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2H4.5A1.5 1.5 0 0 1 3 16.5zM21 5.5A1.5 1.5 0 0 0 19.5 4H14a2 2 0 0 0-2 2v14a2 2 0 0 1 2-2h5.5a1.5 1.5 0 0 0 1.5-1.5z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></symbol>
  <symbol id="drf-i-leaf" viewBox="0 0 24 24"><path d="M5 19c0-8 5-13 15-14-1 10-6 15-14 15M5 19c3-4 6-7 10-9" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></symbol>
  <symbol id="drf-i-info" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 11v6M12 7.5v.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></symbol>
  <symbol id="drf-i-plus" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></symbol>
  <symbol id="drf-i-x" viewBox="0 0 24 24"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></symbol>
  <symbol id="drf-i-arrow" viewBox="0 0 24 24"><path d="M4 12h15M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></symbol>
  <symbol id="drf-i-checks" viewBox="0 0 24 24"><path d="M2 13l4 4 8-9M10 16l1 1 8-9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></symbol>
  <symbol id="drf-i-tri" viewBox="0 0 24 24"><path d="M8 5l9 7-9 7z" fill="currentColor"/></symbol>
  <symbol id="drf-i-up" viewBox="0 0 24 24"><path d="M7 10v10H4V10zM7 10l4-7c1.7 0 2.6 1 2.3 2.6L12.8 9H19a2 2 0 0 1 2 2.3l-1.2 6.9A2 2 0 0 1 17.8 20H7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></symbol>
  <symbol id="drf-i-down" viewBox="0 0 24 24"><g transform="rotate(180 12 12)"><path d="M7 10v10H4V10zM7 10l4-7c1.7 0 2.6 1 2.3 2.6L12.8 9H19a2 2 0 0 1 2 2.3l-1.2 6.9A2 2 0 0 1 17.8 20H7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></g></symbol>
  <symbol id="drf-i-chat" viewBox="0 0 24 24"><path d="M4 5h16v11H9l-5 4z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></symbol>
</svg>

<div class="drf-root"
     [attr.data-mode]="mode()"
     [class.convs-open]="convsOpen()"
     [class.composer-closed]="state() === 'ready' && !composerOpen()">
  @switch (state()) {
    @case ('loading') {
      <div class="df-state" role="status">
        <span class="drf-dots" aria-hidden="true"><i></i><i></i><i></i></span>
        <p>{{ 'dr_future.loading' | translate }}</p>
      </div>
    }
    @case ('disabled') {
      <section class="df-state df-state--card">
        <span class="df-avatar df-avatar--lg" aria-hidden="true"><svg cIcon name="cilCompass" size="xl"></svg></span>
        <h1>{{ 'dr_future.disabled.title' | translate }}</h1>
        <p>{{ 'dr_future.disabled.text' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/', lang, 'dashboard']">{{ 'dr_future.back_to_dashboard' | translate }}</a>
      </section>
    }
    @case ('locked') {
      <!-- A DNA assistant without a finished DNA evaluation (customer text 2026-10-09).
           The backend refuses every call meanwhile; this is only what it looks like. -->
      <section class="df-state df-state--card df-lock">
        <span class="df-avatar df-avatar--lg" aria-hidden="true"><svg cIcon [name]="assistant.icon" size="xl"></svg></span>
        <p class="df-lock__eyebrow"><svg cIcon name="cilLockLocked" size="sm" aria-hidden="true"></svg> {{ assistant.name }}</p>
        <h1>{{ 'dr_future.assistants.locked.title' | translate }}</h1>
        <p>{{ 'dr_future.assistants.locked.body' | translate }}</p>
        @if (dnaStatus() === 'pending') {
          <p class="df-lock__pending" role="status">{{ 'dr_future.assistants.locked.pending' | translate }}</p>
        } @else {
          <p>
            {{ 'dr_future.assistants.locked.no_test' | translate }}
            <a class="df-lock__link" [href]="dnaOfferUrl">{{ 'dr_future.assistants.locked.link_text' | translate }}</a>{{ 'dr_future.assistants.locked.link_after' | translate }}
          </p>
        }
        <a class="btn btn-outline-primary" [routerLink]="['/', lang, 'dashboard']">{{ 'dr_future.back_to_dashboard' | translate }}</a>
      </section>
    }
    @case ('not_connected') {
      <section class="df-state df-state--card">
        <span class="df-avatar df-avatar--lg" aria-hidden="true"><svg cIcon [name]="assistant.icon" size="xl"></svg></span>
        <h1>{{ assistant.name }}</h1>
        <p class="df-lock__eyebrow">{{ 'dr_future.assistants.' + assistant.key + '.description' | translate }}</p>
        <p>{{ 'dr_future.assistants.not_connected.text' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/', lang, 'dashboard']">{{ 'dr_future.back_to_dashboard' | translate }}</a>
      </section>
    }
    @case ('load_error') {
      <section class="df-state df-state--card">
        <h1>{{ isDrFuture ? ('dr_future.title' | translate) : assistant.name }}</h1>
        <p>{{ 'dr_future.errors.generic' | translate }}</p>
        <button type="button" class="btn btn-primary" (click)="ngOnInit()">{{ 'dr_future.reload' | translate }}</button>
      </section>
    }
    @case ('ready') {
      <div class="drf-app">

        <!-- ===== Left: persona, answer mode, conversations ===== -->
        <aside class="drf-side drf-card">
          <div class="drf-persona">
            <div class="drf-avatar-ring">
              @if (isDrFuture) {
                <gh-dr-future-avatar [mode]="mode()" />
              } @else {
                <!-- The DNA assistants have no clips: their icon in the same ring. -->
                <div class="drf-avatar-stage drf-avatar-stage--icon" aria-hidden="true">
                  <svg cIcon [name]="assistant.icon" size="3xl"></svg>
                </div>
              }
            </div>
            <div class="drf-persona-name">{{ assistant.name }}</div>
          </div>

          @if (isDrFuture) {
            <section class="drf-modes">
              <div class="drf-label-row">
                <h2>{{ 'dr_future.modes.title' | translate }}</h2>
                <button type="button" class="drf-icon-btn drf-info-btn" data-drf-popover (click)="toggleModeInfo($event)"
                        [attr.aria-label]="'dr_future.modes.about' | translate" [attr.aria-expanded]="!!popover()">
                  <svg class="drf-i" aria-hidden="true"><use href="#drf-i-info"/></svg>
                </button>
              </div>
              <div class="drf-mode-switch" role="radiogroup" [attr.aria-label]="'dr_future.modes.title' | translate">
                <button type="button" class="drf-mode-opt" data-mode="evidence" role="radio"
                        [attr.aria-checked]="mode() === 'evidence'" [disabled]="busy() && mode() !== 'evidence'"
                        (click)="setMode('evidence')">
                  <span class="drf-mode-title"><svg class="drf-i" aria-hidden="true"><use href="#drf-i-book"/></svg>{{ 'dr_future.modes.evidence.title' | translate }}</span>
                  <span class="drf-mode-sub">{{ 'dr_future.modes.evidence.sub' | translate }}</span>
                </button>
                <button type="button" class="drf-mode-opt" data-mode="alternative" role="radio"
                        [attr.aria-checked]="mode() === 'alternative'" [disabled]="busy() && mode() !== 'alternative'"
                        (click)="setMode('alternative')">
                  <span class="drf-mode-title"><svg class="drf-i" aria-hidden="true"><use href="#drf-i-leaf"/></svg>{{ 'dr_future.modes.alternative.title' | translate }}</span>
                  <span class="drf-mode-sub">{{ 'dr_future.modes.alternative.sub' | translate }}</span>
                </button>
              </div>
              <p class="drf-hint">{{ 'dr_future.modes.hint' | translate }}</p>
            </section>
          }

          <section class="drf-convs" [attr.aria-label]="'dr_future.threads.title' | translate">
            <div class="drf-convs-head">
              <h2>{{ 'dr_future.threads.title' | translate }}</h2>
              <button type="button" class="drf-btn-primary drf-btn-sm" (click)="newConversation()"
                      [disabled]="sending() || !canAsk() || !connected()">
                <svg class="drf-i" aria-hidden="true"><use href="#drf-i-plus"/></svg>{{ 'dr_future.threads.new' | translate }}
              </button>
              <button type="button" class="drf-icon-btn drf-conv-close" (click)="convsOpen.set(false)" [attr.aria-label]="'dr_future.close' | translate">
                <svg class="drf-i" aria-hidden="true"><use href="#drf-i-x"/></svg>
              </button>
            </div>
            @if (threads().length === 0) {
              <p class="drf-conv-empty">{{ 'dr_future.threads.empty' | translate }}</p>
            } @else {
              <ul class="drf-conv-list">
                @for (t of shownThreads(); track t.id) {
                  <li class="drf-conv" tabindex="0"
                      [class.active]="activeThread()?.id === t.id" [class.unread]="t.unread && !t.pending"
                      [attr.aria-current]="activeThread()?.id === t.id ? 'true' : null"
                      (click)="openThread(t)" (keydown)="onThreadKeydown($event, t)">
                    <span class="drf-conv-title">{{ t.title || ('dr_future.untitled' | translate) }}</span>
                    <button type="button" class="drf-icon-btn drf-conv-del" (click)="archive(t, $event)"
                            [attr.aria-label]="'dr_future.threads.archive' | translate" [title]="'dr_future.threads.archive' | translate">
                      <svg class="drf-i" aria-hidden="true"><use href="#drf-i-x"/></svg>
                    </button>
                    <span class="drf-conv-body">
                      <span class="drf-conv-when">
                        <span>{{ fmtWhen(t) }}</span>
                        @if (isDrFuture) {
                          <span class="drf-conv-dot" [class]="'drf-conv-dot ' + threadModeOf(t)" [class.is-pending]="t.pending"
                                [title]="(t.pending ? 'dr_future.threads.pending' : 'dr_future.modes.' + threadModeOf(t) + '.pill') | translate"></span>
                        } @else if (t.pending) {
                          <span class="drf-conv-dot evidence is-pending" [title]="'dr_future.threads.pending' | translate"></span>
                        }
                      </span>
                      <span class="drf-conv-preview">
                        @if (t.unread && !t.pending) { <span class="visually-hidden">{{ 'dr_future.threads.unread' | translate }}: </span> }
                        {{ t.last_message?.preview }}
                      </span>
                    </span>
                  </li>
                }
              </ul>
              @if (hasMoreThreads()) {
                <button type="button" class="drf-link-btn drf-view-all" (click)="toggleViewAll()">
                  {{ (viewAll() ? 'dr_future.threads.show_fewer' : 'dr_future.threads.view_all') | translate }}
                </button>
              }
            }
          </section>
        </aside>

        <!-- ===== Right: chat ===== -->
        <section class="drf-chat drf-card">
          <header class="drf-chat-head">
            <button type="button" class="drf-icon-btn drf-conv-toggle" (click)="toggleConvs()"
                    [attr.aria-label]="'dr_future.threads.title' | translate" [attr.aria-expanded]="convsOpen()">
              <svg class="drf-i" aria-hidden="true"><use href="#drf-i-chat"/></svg>
            </button>
            <div class="drf-head-icon" aria-hidden="true">
              @if (isDrFuture) {
                <svg class="drf-i"><use [attr.href]="mode() === 'alternative' ? '#drf-i-leaf' : '#drf-i-book'"/></svg>
              } @else {
                <svg cIcon [name]="assistant.icon"></svg>
              }
            </div>
            <div class="drf-head-text">
              <h1>{{ activeThread()?.title || ('dr_future.threads.new' | translate) }}</h1>
              @if (isDrFuture) {
                <p>{{ 'dr_future.modes.' + mode() + '.chat_sub' | translate }}</p>
              } @else {
                <p>{{ assistant.name }} · {{ 'dr_future.assistants.' + assistant.key + '.description' | translate }}</p>
              }
            </div>
            @if (isDrFuture) {
              <div class="drf-mode-pill">
                <img class="drf-pill-avatar" [src]="avatarSmall(mode())" alt="">
                <svg class="drf-i drf-pill-icon" aria-hidden="true"><use [attr.href]="mode() === 'alternative' ? '#drf-i-leaf' : '#drf-i-book'"/></svg>
                <span>{{ 'dr_future.modes.' + mode() + '.pill' | translate }}</span>
                <button type="button" class="drf-icon-btn drf-info-btn" data-drf-popover (click)="toggleModeInfo($event)"
                        [attr.aria-label]="'dr_future.modes.about' | translate" [attr.aria-expanded]="!!popover()">
                  <svg class="drf-i" aria-hidden="true"><use href="#drf-i-info"/></svg>
                </button>
              </div>
            }
          </header>

          <div class="drf-messages" #scroller aria-live="polite">
            @if (loadingThread()) {
              <div class="df-state" role="status"><span class="drf-dots" aria-hidden="true"><i></i><i></i><i></i></span></div>
            } @else {
              <!-- The greeting: first bubble of EVERY conversation and the empty state. Our own
                   copy (may carry **bold**) — never stored, never sent, no feedback, no sources. -->
              <div class="drf-msg bot" role="note">
                <ng-container *ngTemplateOutlet="botAvatar" />
                <div class="drf-msg-col">
                  <div class="drf-bubble">
                    <div class="drf-answer is-greeting">
                      @if (beta) { <span class="drf-badge beta">{{ 'dr_future.beta' | translate }}</span> }
                      @if (isDrFuture) {
                        @for (para of ('dr_future.greeting.' + conversationMode() | translate) | drfOwnText; track $index) {
                          <p>@for (line of para; track $index) {@if (!$first) {<br>}@for (seg of line; track $index) {@if (seg.bold) {<b>{{ seg.text }}</b>} @else {<ng-container>{{ seg.text }}</ng-container>}}}</p>
                        }
                        <!-- Holistic cannot be asked anything yet, so its greeting says so last —
                             where the reader ends up, rather than in a banner they skip. -->
                        @if (conversationMode() === 'alternative' && !alternativeModeEnabled()) {
                          <p class="drf-soon-line"><b>{{ 'dr_future.modes.coming_soon' | translate }}</b></p>
                        }
                      } @else {
                        @for (para of ('dr_future.assistants.' + assistant.key + '.welcome' | translate: nameParams) | drfOwnText; track $index) {
                          <p>@for (line of para; track $index) {@if (!$first) {<br>}@for (seg of line; track $index) {@if (seg.bold) {<b>{{ seg.text }}</b>} @else {<ng-container>{{ seg.text }}</ng-container>}}}</p>
                        }
                        @if (assistant.key === 'biotune') {
                          <p class="drf-scope-note">{{ 'dr_future.assistants.biotune.scope_note' | translate }}</p>
                        }
                      }
                    </div>
                  </div>
                  @if (activeThread()) { <div class="drf-msg-time">{{ fmtTime(activeThread()?.created_at) }}</div> }
                </div>
              </div>

              @for (m of messages(); track m.id) {
                @if (m.role === 'user') {
                  <div class="drf-msg user">
                    <div class="drf-msg-col">
                      <div class="drf-bubble">{{ m.content }}</div>
                      <div class="drf-msg-time">{{ fmtTime(m.created_at) }}<svg class="drf-i" aria-hidden="true"><use href="#drf-i-checks"/></svg></div>
                    </div>
                  </div>
                } @else if (m.status === 'pending') {
                  <div class="drf-msg bot typing">
                    <ng-container *ngTemplateOutlet="botAvatar" />
                    <div class="drf-msg-col">
                      <div class="drf-bubble" role="status">
                        <span class="drf-dots" aria-hidden="true"><i></i><i></i><i></i></span>{{ named('dr_future.typing') | translate: nameParams }}
                      </div>
                    </div>
                  </div>
                } @else {
                  <!-- `urgent` sits on the message, not inside it, so the bubble AND its tail carry
                       the urgency. Handoff is never styled in the mode accent: urgency must not read
                       as "evidence blue" or "alternative green". -->
                  <div class="drf-msg bot" [class.urgent]="m.status === 'handoff'">
                    <ng-container *ngTemplateOutlet="botAvatar" />
                    <div class="drf-msg-col">
                      <div class="drf-bubble">
                        <div class="drf-answer" [class]="'drf-answer is-' + statusOf(m)">
                          @if (beta) { <span class="drf-badge beta">{{ 'dr_future.beta' | translate }}</span> }
                          <span class="drf-badge status">{{ 'dr_future.status.' + statusOf(m) | translate }}</span>

                          @if (statusOf(m) === 'error') {
                            <!-- Our problem, not the corpus's: muted, with a way out. Never a canned answer. -->
                            @if (m.status === 'error' && m.content) {
                              @for (block of m.content | drfAnswer: 0; track $index) {
                                @if (block.kind === 'p') {
                                  <p>@for (line of block.lines; track $index) {@if (!$first) {<br>}@for (seg of line; track $index) {<ng-container>{{ seg.text }}</ng-container>}}</p>
                                }
                              }
                            }
                            <p>{{ (m.status === 'error' ? 'dr_future.errors.provider_hint' : failureKey(m)) | translate: nameParams }}</p>
                            @if (canRetry(m)) {
                              <div class="drf-retry-row">
                                <button type="button" class="drf-btn-primary drf-btn-sm" (click)="retry(m)" [disabled]="pending()">
                                  {{ 'dr_future.retry' | translate }}
                                </button>
                              </div>
                            }
                          } @else {
                            @if (m.status === 'answer' && m.sources.length) {
                              <div class="drf-lead">{{ 'dr_future.modes.' + conversationMode() + '.lead' | translate }}</div>
                            }
                            <!-- Plain text by contract, parsed into segments and interpolated — never innerHTML. -->
                            @for (block of m.content | drfAnswer: m.sources.length; track $index) {
                              @if (block.kind === 'ul') {
                                <ul>
                                  @for (item of block.items; track $index) {
                                    <li>@for (seg of item; track $index) {@if (seg.cite) {<button type="button" class="drf-cite" (click)="cite(m, seg.cite)" [attr.aria-label]="'dr_future.sources.cite' | translate: { n: seg.cite }">[{{ seg.cite }}]</button>} @else {<ng-container>{{ seg.text }}</ng-container>}}</li>
                                  }
                                </ul>
                              } @else {
                                <p>@for (line of block.lines; track $index) {@if (!$first) {<br>}@for (seg of line; track $index) {@if (seg.cite) {<button type="button" class="drf-cite" (click)="cite(m, seg.cite)" [attr.aria-label]="'dr_future.sources.cite' | translate: { n: seg.cite }">[{{ seg.cite }}]</button>} @else {<ng-container>{{ seg.text }}</ng-container>}}}</p>
                              }
                            }

                            @if (m.status === 'handoff') {
                              <!-- Our way to a person: the human Health Concierge, question pre-filled. -->
                              <div class="drf-handoff-row">
                                <p>{{ 'dr_future.handoff.text' | translate }}</p>
                                <button type="button" class="drf-btn-handoff drf-btn-sm" (click)="handoff(m)">
                                  {{ 'dr_future.handoff.cta' | translate }} <svg class="drf-i" aria-hidden="true"><use href="#drf-i-arrow"/></svg>
                                </button>
                              </div>
                            }

                            @if (m.sources.length) {
                              <!-- Provenance only: the endpoint returns no excerpt, and none is invented. -->
                              <div class="drf-sources">
                                <button type="button" class="drf-src-toggle" [attr.aria-expanded]="sourcesExpanded(m)" (click)="toggleSources(m)">
                                  <svg class="drf-i" aria-hidden="true"><use href="#drf-i-tri"/></svg>{{ 'dr_future.sources.toggle' | translate: countParams(m) }}
                                </button>
                                <ol class="drf-src-list" [hidden]="!sourcesExpanded(m)">
                                  @for (s of m.sources; track $index) {
                                    <li [id]="'drf-src-' + m.id + '-' + ($index + 1)" [class.flash]="flashedSource() === m.id + '-' + ($index + 1)">
                                      <span class="drf-src-title">{{ s.title }}</span>
                                      @if (s.section || s.source_type || sourceOrigin(s)) {
                                        <span class="drf-src-meta">
                                          @if (s.section) { · {{ s.section }} } @else if (s.source_type) { · {{ sourceTypeLabel(s) }} }
                                          @if (sourceOrigin(s)) { · <span class="drf-src-origin" [title]="s.organization ?? ''">{{ sourceOrigin(s) }}</span> }
                                        </span>
                                      }
                                      @if (s.url) { &ngsp;<a [href]="s.url" target="_blank" rel="noopener noreferrer">{{ 'dr_future.sources.open' | translate }}</a> }
                                      <!-- The excerpt. Empty today (no `snippet` in the response yet) and kept on purpose:
                                           it is the line that must not be deleted as dead code (template CHANGES.md §2). -->
                                      @if (s.snippet) { <p class="drf-src-snip">{{ s.snippet }}</p> }
                                    </li>
                                  }
                                </ol>
                              </div>
                            }

                            @if (m.feedback_allowed) {
                              <div class="drf-feedback" role="group" [attr.aria-label]="'dr_future.feedback.useful' | translate">
                                <span>{{ 'dr_future.feedback.useful' | translate }}</span>
                                <button type="button" class="drf-fb-btn" [attr.aria-pressed]="m.feedback?.rating === 'up'"
                                        [disabled]="feedbackSaving() === m.id" (click)="rate(m, 'up')">
                                  <svg class="drf-i" aria-hidden="true"><use href="#drf-i-up"/></svg>{{ 'dr_future.feedback.yes' | translate }}
                                </button>
                                <button type="button" class="drf-fb-btn" [attr.aria-pressed]="m.feedback?.rating === 'down'"
                                        [disabled]="feedbackSaving() === m.id" (click)="rate(m, 'down')">
                                  <svg class="drf-i" aria-hidden="true"><use href="#drf-i-down"/></svg>{{ 'dr_future.feedback.no' | translate }}
                                </button>

                                @if (feedbackOpenFor() === m.id) {
                                  <form class="drf-fb-comment" (ngSubmit)="submitFeedbackComment(m)">
                                    <textarea name="feedbackComment" [maxlength]="feedbackMaxLength"
                                              [ngModel]="feedbackDraft()" (ngModelChange)="feedbackDraft.set($event)"
                                              [attr.aria-label]="'dr_future.feedback.comment_placeholder' | translate"
                                              [placeholder]="'dr_future.feedback.comment_placeholder' | translate"></textarea>
                                    <div class="drf-fb-actions">
                                      <button type="button" class="drf-link-btn" (click)="skipFeedbackComment(m)">{{ 'dr_future.feedback.skip' | translate }}</button>
                                      <button type="submit" class="drf-btn-primary drf-btn-sm" [disabled]="feedbackSaving() === m.id">{{ 'dr_future.feedback.send' | translate }}</button>
                                    </div>
                                  </form>
                                } @else if (feedbackThankedFor(m)) {
                                  <span class="drf-fb-thanks" role="status">{{ 'dr_future.feedback.sent' | translate }}</span>
                                }
                                @if (feedbackSaveError() === m.id) {
                                  <span class="drf-fb-thanks warn" role="alert">{{ 'dr_future.feedback.send_failed' | translate }}</span>
                                } @else if (m.feedback?.sync_status === 'failed') {
                                  <span class="drf-fb-thanks warn">{{ 'dr_future.feedback.not_sent' | translate }}</span>
                                }
                              </div>
                            }
                          }
                        </div>
                      </div>
                      <div class="drf-msg-time">{{ fmtTime(m.updated_at) }}</div>
                    </div>
                  </div>
                }
              }

              @if (slow()) {
                <div class="drf-notice">
                  <p>{{ named('dr_future.slow') | translate: nameParams }}</p>
                  <button type="button" class="drf-btn-primary drf-btn-sm" (click)="checkAgain()">{{ 'dr_future.check_again' | translate }}</button>
                </div>
              }
            }
          </div>

          <footer class="drf-composer">
            @if (sendError()) {
              <div class="drf-alert" role="alert">{{ sendError() }}</div>
            }
            @if (!connected()) {
              <p class="drf-composer-note">{{ 'dr_future.assistants.not_connected.text' | translate }}</p>
            } @else if (!canAsk()) {
              <div class="drf-membership">
                <strong>{{ named('dr_future.membership.title') | translate: nameParams }}</strong>
                <p>{{ named('dr_future.membership.text') | translate: nameParams }}</p>
                <a class="drf-btn-primary drf-btn-sm" [routerLink]="['/', lang, 'membership', 'apply']">{{ 'dr_future.membership.cta' | translate }}</a>
              </div>
            } @else if (activeThread()?.archived) {
              <p class="drf-composer-note">{{ 'dr_future.archived_note' | translate }}</p>
            } @else {
              <form (ngSubmit)="send()">
                <div class="drf-input-wrap">
                  <textarea #composer class="drf-input" name="question" rows="1" [maxlength]="maxLength"
                            [ngModel]="question()" (ngModelChange)="onQuestionInput($event)"
                            (keydown)="onComposerKeydown($event)"
                            [disabled]="!composerOpen() || sending()"
                            [placeholder]="(composerOpen()
                              ? (activeThread() ? named('dr_future.composer.placeholder_follow_up') : (isDrFuture ? 'dr_future.composer.placeholder_follow_up' : 'dr_future.composer.placeholder'))
                              : 'dr_future.modes.composer_closed') | translate: nameParams"
                            [attr.aria-label]="'dr_future.composer.label' | translate"></textarea>
                </div>
                <div class="drf-composer-meta">
                  <div class="drf-composer-notes">
                    <span>{{ 'dr_future.composer.hint' | translate }}</span>
                    <span class="drf-note-full">{{ named('dr_future.disclaimer') | translate: nameParams }}</span>
                    <span class="drf-note-short">{{ named('dr_future.disclaimer_short') | translate: nameParams }}</span>
                  </div>
                  <span class="drf-counter" [class.near]="question().length > maxLength * 0.95">{{ question().length }} / {{ maxLength }}</span>
                  <button type="submit" class="drf-btn-primary drf-send" [disabled]="!canSend()">
                    {{ 'dr_future.composer.send' | translate }} <svg class="drf-i" aria-hidden="true"><use href="#drf-i-arrow"/></svg>
                  </button>
                </div>
              </form>
            }
          </footer>
        </section>
      </div>
    }
  }
</div>

<!-- Outside `.drf-root` on purpose: the root is a size container, and container
     containment would make it the containing block of this fixed-position popover. -->
@if (popover(); as pos) {
  <div class="drf-popover" role="dialog" [attr.aria-label]="'dr_future.modes.about' | translate"
       [style.left.px]="pos.left" [style.top.px]="pos.top">
    @for (para of ('dr_future.modes.info' | translate) | drfOwnText; track $index) {
      <p>@for (line of para; track $index) {@if (!$first) {<br>}@for (seg of line; track $index) {@if (seg.bold) {<b>{{ seg.text }}</b>} @else {<ng-container>{{ seg.text }}</ng-container>}}}</p>
    }
  </div>
}

<ng-template #botAvatar>
  @if (isDrFuture) {
    <img class="drf-msg-avatar" [src]="avatarSmall(conversationMode())" [alt]="assistant.name">
  } @else {
    <span class="drf-msg-avatar drf-msg-avatar--icon" aria-hidden="true"><svg cIcon [name]="assistant.icon"></svg></span>
  }
</ng-template>
